export default {
  "content": "<g clip-path=\"url(#clip0_495_6523)\"><path d=\"M8 0a8 8 0 100 16A8 8 0 008 0zm0 2.833a1 1 0 110 2 1 1 0 010-2zM10 13H6v-2h1V9H6V7h2a1 1 0 011 1v3h1v2z\" fill=\"#6161FF\"/></g><defs><clipPath id=\"clip0_495_6523\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};